const listTranslations = async (language) => {
    try {
        const fetchUrl = `https://api.digi-youth.com/translations/get?language=${language}`;
        const response = await fetch(fetchUrl, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            }
        })

        if (!response.ok) {
            response.message = 'Get translations failed'
        }

        return await response.json();
    } catch (error) {
        // Handle and log errors here
        throw error;
    }
};

export { listTranslations };
